import theperiodsofwesternclassicaleramumbai from '../Images/Blogs/the-periods-of-western-classical-era-mumbai.jpg';
import discoverbachlegacyinmumbai from '../Images/Blogs/discover-bach-legacy-in-mumbai.jpg';
import top10factsaboutbeethoven from '../Images/Blogs/top-10-facts-about-beethoven.jpg';
import howmozartchangedclassicalmusic from '../Images/Blogs/how-mozart-changed-classical-music.jpg';
import whychopinsmusicstillinspires from '../Images/Blogs/why-chopins-music-still-inspires.jpg';
import discovershostakovichtimelessmusiclegacy from '../Images/Blogs/discover-shostakovich-timeless-music-legacy.jpg'

const blogMeta = [
    
    {
      image: discovershostakovichtimelessmusiclegacy,
      id: 'discover-shostakovich-timeless-music-legacy',
      title: 'Shostakovich’s Timeless Music Legacy | Sur Saathi',
      description: 'Discover how Shostakovich’s timeless music inspires the world. Explore his legacy with Sur Saathi, a leading music initiative and school in Mumbai.',
    },
    {
      image: theperiodsofwesternclassicaleramumbai,
      id: 'the-periods-of-western-classical-era-mumbai',
      title: 'The Periods of Western Classical Era',
      description: 'Discover the periods of Western Classical Era with Sur Saathi, Mumbai’s leading music initiative. Explore history, composers, and timeless influence.',
    },
    {
      image: discoverbachlegacyinmumbai,
      id: 'johann-sebastian-bach-life-works-legacy',
      title: 'Johann Sebastian Bach: Life & Legacy of the Baroque Master',
      description: 'Explore Johann Sebastian Bach’s life, works, and lasting legacy. Discover the Baroque master’s music, influence, and timeless genius.',
    },
    {
      image: top10factsaboutbeethoven,
      id: 'top-10-facts-about-beethoven',
      title: 'Top 10 Facts About Beethoven You Didn’t Know',
      description: 'Discover 10 fascinating facts about Beethoven, the legendary composer. Learn how his music inspires Sur Saathi, a leading music initiative in Mumbai.',
    },
    {
      image: howmozartchangedclassicalmusic,
      id: 'how-mozart-changed-classical-music',
      title: 'How Mozart Changed Classical Music Forever',
      description: 'Discover how Mozart transformed classical music and why his legacy inspires music schools, programs, and learners at Sur Saathi in Mumbai.',
    },
    {
      image: whychopinsmusicstillinspires,
      id: 'why-chopins-music-still-inspires',
      title: 'Why Chopin’s Music Still Inspires the World',
      description: 'Explore why Chopin’s music continues to inspire musicians and learners worldwide. Discover how Sur Saathi, a music initiative in Mumbai, carries his legacy.',
    },
  ];
  
  export default blogMeta;